import HtmlText from '@/components/promo/HtmlText';
import { useI18n } from '@/contexts/I18nContext';
import { getText } from '@/lib/utils/i18nText';

const CONTACT_URL = 'https://www.ggcontent.com/contact';

export default function LetsTalk() {
  const { t } = useI18n();

  return (
    <section className="call4action">
      <div className="dot-overlay" />
      <div className="content">
        <h3>LET'S TALK</h3>
        <HtmlText html={t('letstalk.desc')} as="p" />

        {/* 안내 문구 */}
        {/* <p style={{ color: '#fff', fontSize: 16, marginBottom: 16, lineHeight: 1.6 }}>
          {getText(
            'This contact form is currently disabled. Please use the link below instead.',
            '이 문의 양식은 현재 비활성화되어 있습니다. 아래 링크를 이용해 주세요.',
          )}
        </p> */}
        <a
          href={CONTACT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-gc"
          style={{ display: 'inline-block', textDecoration: 'none' }}
        >
          {getText('Go to Contact Page', '문의 페이지로 이동')}
        </a>

        {/* disabled 폼 */}
        {/* <form
          onSubmit={(e) => e.preventDefault()}
          style={{ opacity: 0.4, pointerEvents: 'none', marginTop: 24 }}
        >
          <div className="form-row">
            <input type="text" placeholder="First and Last Name" name="name" disabled />
            <input type="email" placeholder="Email" name="email" disabled />
          </div>
          <div style={{ marginBottom: 12 }}>
            <textarea placeholder="Message" name="message" rows={5} disabled />
          </div>
          <button type="submit" className="btn-gc" disabled>
            {getText('Contact us', '문의하기')}
          </button>
        </form> */}
      </div>
    </section>
  );
}
